import { Component, EventEmitter, OnInit, ViewChild, ViewChildren } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { PMSPartner, PMSPartnerUser } from '../../models/pmspartner';
import { PmsManagementService } from '../../services/pms-management.service';
import { ClientService } from 'src/app/clients-module/services/client.service';

@Component({
  selector: 'app-add-pms-user',
  templateUrl: './add-pms-user.component.html',
  styleUrls: ['./add-pms-user.component.less']
})
export class AddPmsUserComponent implements OnInit {

  @ViewChild('newpmsuser', {}) ngForm: NgForm;
  onSavedEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  newUser: PMSPartnerUser;

  showNewPMSPartnerInput: boolean = false;
  newPmsPartnerName: string;

  constructor(public pmsService: PmsManagementService, public modalService: NgbModal, private toast: ToastrService, public clients : ClientService) { }

  ngOnInit() {
    this.newUser = new PMSPartnerUser();
  }

  cancel(): void {
    this.modalService.dismissAll();
  }

  addPMSPartner(): void {
    this.showNewPMSPartnerInput = true;
  }


  save(): void {
    //if there's a new partner, save it, then set it on the new user
    //the form will be invalid on the first pass here because parter is not set..
    if(this.newPmsPartnerName) {
      let newPartner: PMSPartner = new PMSPartner();
      newPartner.partnerName = this.newPmsPartnerName;
      this.pmsService.CreatePMSPartner(newPartner).subscribe((res: PMSPartner) => {
        if(res) {
          this.pmsService.pmsPartners.push(res);
          this.newPmsPartnerName = null;
          this.showNewPMSPartnerInput = false;
          this.newUser.pmsPartnerId = res.id;
        }
      },
      err => { this.toast.error('Error saving new PMS Partner. Partner may already exist.') })
      return;
    }
    if(this.ngForm.valid) {

      this.pmsService.CreatePMSUser(this.newUser).subscribe(res => {
        if (res) {
          let datToast = this.toast.success('PMS Partner user saved!',`Click here to copy your new PMS user password to clip board.`, { disableTimeOut: true });
          // RIQ-1970: disable the PW on manual download files.. saving this code because it will likely come in handy again
          datToast.onTap.subscribe(()=>{
            if(navigator.clipboard){
              navigator.clipboard.writeText(res.password).then((scc: any)=>{
                this.toast.clear(datToast.toastId);
                this.toast.info('Your PMS password has been copied to the clipboard.');
              },
              (err: any)=>{
                this.toast.error('Error copying password to your clipboard.')
              });

            }
          })

          this.onSavedEvent.next(true);
          this.modalService.dismissAll();
        }
      },
      err => { this.toast.error('Error saving PMS Partner user', '', { closeButton: true, disableTimeOut: true }) },
      () => {})
    }
  }

}
